exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".container__3gcHm{background-color:#fff;border-radius:8px;padding:24px 16px}", "", {"version":3,"sources":["/opt/build/repo/src/components/VideoCallRating/VideoCallRating.styles.scss"],"names":[],"mappings":"AAAA,kBACE,sBACA,kBACA,iBAAkB,CACnB","file":"VideoCallRating.styles.scss","sourcesContent":[".container {\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 24px 16px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "container__3gcHm"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/VideoCallRating/VideoCallRating.styles.scss
// module id = O0HZ
// module chunks = 0